import React, { useState } from 'react';
import { Plus, Minus } from 'lucide-react';
import { faqs } from '../mock';

export default function Faq() {
  const [open, setOpen] = useState(-1);
  return (
    <section className="section">
      <div className="container-x">
        <div className="grid lg:grid-cols-[0.8fr_1.2fr] gap-12">
          <div className="reveal">
            <p className="eyebrow mb-2">Good to Know</p>
            <h2 style={{ fontSize: 'clamp(2rem, 4vw, 3rem)' }}>Answers before you ask</h2>
            <p className="mt-5" style={{ color: 'var(--muted)' }}>
              Straight answers about our care, scope, and process. Have another question? We&rsquo;re
              always happy to talk it through.
            </p>
          </div>

          <div className="reveal flex flex-col gap-3">
            {faqs.map((f, idx) => {
              const on = idx === open;
              return (
                <div key={f.q} className="rounded-2xl bg-white overflow-hidden" style={{ border: '1px solid var(--line)' }}>
                  <button
                    onClick={() => setOpen(on ? -1 : idx)}
                    className="w-full flex items-center justify-between gap-4 text-left px-6 py-5"
                  >
                    <span className="font-semibold text-[17px]" style={{ color: 'var(--forest)' }}>{f.q}</span>
                    <span className="flex items-center justify-center rounded-full shrink-0" style={{ width: 32, height: 32, backgroundColor: on ? 'var(--forest)' : 'var(--sage-soft)' }}>
                      {on ? <Minus size={17} color="#fff" /> : <Plus size={17} style={{ color: 'var(--forest)' }} />}
                    </span>
                  </button>
                  <div style={{ maxHeight: on ? 240 : 0, transition: 'max-height 0.4s ease', overflow: 'hidden' }}>
                    <p className="px-6 pb-6 pt-0" style={{ color: 'var(--muted)' }}>{f.a}</p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
